export class AreaAtividade {
  public areaAtividade?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
